import { render, staticRenderFns } from "./communitylist.vue?vue&type=template&id=11c7d0a5&scoped=true&"
import script from "./communitylist.vue?vue&type=script&lang=js&"
export * from "./communitylist.vue?vue&type=script&lang=js&"
import style0 from "./communitylist.vue?vue&type=style&index=0&id=11c7d0a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c7d0a5",
  null
  
)

export default component.exports